import { Injectable } from '@angular/core';
import { PagedResponse, RequestResponse } from '@core/services/request/model/request.model';
import { HttpParamsService } from '@core/services/http-params/http-params.service';
import { ApiDirectory } from '@core/api/api-directory';
import { RequestService } from '@core/services/request/request.service';
import { Observable, of } from 'rxjs';
import { IndividualInvoiceApi } from '@core/api/model/my-invoices/individual-invoice-api.model';
import { MyInvoicesListingApi, MyInvoicesListingFilterApi } from '@core/api/model/my-invoices/invoice-api.model';
import { catchError, map } from 'rxjs/operators';
import { LoadingIds } from '@shared/constants/loading';

@Injectable({
  providedIn: 'root',
})
export class ApiMyInvoicesService {
  /**
   *
   * @param _requestService @see RequestService
   * @param _tableParamsService @see TableParamsService
   */
  constructor(
    private _requestService: RequestService,
    private readonly _tableParamsService: HttpParamsService
  ) {}

  /**
   * Fetch invoices for the invoices page
   */
  public fetchInvoices(request: MyInvoicesListingFilterApi): Observable<RequestResponse<PagedResponse<MyInvoicesListingApi>>> {
    return this._requestService.get(ApiDirectory.Facturas.Facturas({}), {
      params: this._tableParamsService.toParams(request),
      loading: LoadingIds.FETCH_MY_INVOICES_LISTING,
      hideErrorAlert: true,
    });
  }

  /**
   * Fetch an invoice given its invoice number
   */
  public fetchSingleInvoice(code: string): Observable<RequestResponse<IndividualInvoiceApi>> {
    return this._requestService.get<RequestResponse<IndividualInvoiceApi>>(
      ApiDirectory.Facturas.Factura({
        numFactura: encodeURIComponent(code),
      }),
      { hideErrorAlert: true }
    );
  }

  public checkInvoiceCupsExist(code: string, cups: string): Observable<boolean> {
    return this._requestService
      .get<RequestResponse<IndividualInvoiceApi>>(
        ApiDirectory.Facturas.Factura({
          numFactura: encodeURIComponent(code),
        }),
        {
          hideErrorAlert: true,
        }
      )
      .pipe(
        map((response) => response.data.cups === cups),
        catchError(() => of(false))
      );
  }
}
